import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BarcodeFormat } from '@zxing/library';

@Component({
    selector: 'barcode-scanner',
    template: require('./barcode-scanner.component.html'),
    styles: [require('./barcode-scanner.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BarcodeScannerComponent implements OnInit {

    @Input()
    public showActionButtons = false;

    @Output()
    public barcodeEvent: EventEmitter<{}> = new EventEmitter<{}>();

    public allowedFormats: BarcodeFormat[] = [];
    public barcodeData: string;

    public cameraList: MediaDeviceInfo[];
    public selectedCamera: MediaDeviceInfo = null;
    public camIndex = 0;

    public ngOnInit(): void {
        this.allowedFormats = [
            BarcodeFormat.AZTEC,
            BarcodeFormat.CODABAR,
            BarcodeFormat.CODE_128,
            BarcodeFormat.CODE_39,
            BarcodeFormat.CODE_93,
            BarcodeFormat.DATA_MATRIX,
            BarcodeFormat.EAN_13,
            BarcodeFormat.EAN_8,
            BarcodeFormat.ITF,
            BarcodeFormat.MAXICODE,
            BarcodeFormat.PDF_417,
            BarcodeFormat.QR_CODE,
            BarcodeFormat.RSS_14,
            BarcodeFormat.RSS_EXPANDED,
            BarcodeFormat.UPC_A,
            BarcodeFormat.UPC_E,
            BarcodeFormat.UPC_EAN_EXTENSION,
        ];
    }

    public onCamerasFound(devices: MediaDeviceInfo[]): void {
        if (devices && devices.length) {
            this.cameraList = devices;
            const backCamera = this.cameraList.find(camera => camera.label.includes('back'));
            if (backCamera) {
                this.selectedCamera = backCamera;
            }
        }
    }

    public onCamerasNotFound(): void {
        console.debug('onCamerasNotFound');
    }

    public onScanSuccess(e: any): void {
        this.barcodeData = e;
        if (!this.showActionButtons) {
            this.onBarcodeActionClick(true);
        }
    }

    public onScanFailure(): void {
        //    console.debug('onScanFailure');
    }

    public onScanError(e: any): void {
        console.debug(e);
    }

    public onScanComplete(e: any): void {
        console.debug(e);
    }

    public onBarcodeActionClick(isSaveClicked: boolean): void {
        this.barcodeEvent.emit({
            isSaveClicked,
            barcodeData: this.barcodeData
        });
    }

    public switchCamera() {
        (this.camIndex >= this.cameraList.length - 1) ? this.camIndex = 0 : this.camIndex++;
        this.selectedCamera = this.cameraList[this.camIndex] || this.cameraList[0];
    }
}
